<script lang="ts">
    import { triggerClickOnEnterOrSpace } from "../../../../Utils/svelte-a11y";

    interface Props {
        collisionGrid: number[][];
        collisionGridHeight: number;
        updateCollisionGrid: (rowIndex: number, columnIndex: number) => void;
    }

    let { collisionGrid = [], collisionGridHeight, updateCollisionGrid }: Props = $props();
</script>

<div class="absolute w-32 grid gap" style={`height: ${collisionGridHeight}px`}>
    {#each collisionGrid as row, rowIndex (rowIndex)}
        {#each row as _, columnIndex (columnIndex)}
            <div
                style={`grid-area: ${rowIndex + 1} / ${columnIndex + 1}`}
                role="button"
                tabindex="0"
                aria-pressed={collisionGrid[rowIndex][columnIndex] === 1}
                aria-label={`Ячейка коллизии ${rowIndex + 1}, ${columnIndex + 1}`}
                class={[
                    "cursor-pointer border-solid border border-gray-400 rounded-sm",
                    {
                        "bg-red-600/30": collisionGrid[rowIndex][columnIndex] === 1,
                    },
                ]}
                onclick={() => updateCollisionGrid(rowIndex, columnIndex)}
                onkeydown={triggerClickOnEnterOrSpace}
            ></div>
        {/each}
    {/each}
</div>
